import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperBuyProductPayPage } from './shopper-buy-product-pay';

@NgModule({
  declarations: [
    ShopperBuyProductPayPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperBuyProductPayPage),
    TranslateModule.forChild()
  ],
})
export class ShopperBuyProductPayPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-product-pay/shopper-buy-product-pay.module.ts